import React from 'react';
import { Route, Redirect } from 'react-router-dom';

function ApproversRoute({component: Component, ...restProps}) {
    const approvers = localStorage.getItem('isApprovers');

    return <Route
        {...restProps}
        render = {props => {
            return approvers ? <Component {...props} /> : <Redirect to={{pathname: '/login'}} />
        }}
    />
}

export default ApproversRoute;